import { CustomEventNames } from '../../../constants/events';
import { invalidateFintechMmContractCaches } from '../../../services/FintechMm/invalidateFintechMmContractCaches';

type OpenMarketPlaceWCProps = {
  productId: string,
  triggerSource: string,
  codParc: string,
  isTrial: boolean,
  trialFinalDate: string,
  currentPlanId: string,
  purchaseDate: string,
  contractCodeOm?: string,
}

export function openMarketPlaceWebComponent(params: OpenMarketPlaceWCProps) {
  if (!params) {
    return;
  }

  const { 
    productId,
    triggerSource,
    codParc,
    isTrial,
    trialFinalDate,
    currentPlanId,
    purchaseDate,
    contractCodeOm
  } = params;

  document.addEventListener(
    CustomEventNames.MKP_ORDER_CONFIRMED,
    () => {
      invalidateFintechMmContractCaches();
    },
    { once: true },
  );

  document.dispatchEvent(
    new CustomEvent(CustomEventNames.MKP_CHECKOUT_OPEN, {
      detail: {
        productId,
        triggerSource,
        codParc,
        isTrial,
        trialFinalDate,
        currentPlanId,
        purchaseDate,
        contractCodeOm
      },
    }),
  );
}